import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    available: '待选项',
    selected: '已选项',
    selectAll: '全选',
    deselectAll: '清空',
    expand: '展开项目',
    collapse: '收起项目',
    noData: '没有待选项',
    select: '请选择',
    remove: '移除'
  },
  {
    ns: 'transfer'
  }
)
